import React from 'react';
import ShopifyOrderSearchResult from '../shopify/ShopifyOrderSearchResult';
import ZendeskOrderSearchResult from './ZendeskOrderSearchResult/ZendeskOrderSearchResult';
import TicketSearchResult from './TicketSearchResult';
import KbOrMacroSearchResult from './KbOrMacroSearchResult';
import * as searchTypes from '../../../constants/searchTypes';
import AmazonOrderSearchResult from '../amazon/AmazonOrderSearchResult';
import CustomSellerOrderSearchResult from './CustomSellerOrderSearchResult';
import SimplrOrderSearchResult from '../simplrOrder/SimplrOrderSearchResult';
import CancelSubscriptionResult from './CancelSubscriptionResult/CancelSubscriptionResult';
import DTOrderSearchResult from '../common/DTOrderSearchResult/DTOrderSearchResult';
import DTReturnsSearchResult from '../../DecisionTree/Common/DTReturnsSearchResult/DTReturnsSearchResult';
import RbiSearchResultComponent from '../rbi/RbiSearchResultComponent';
import SalesforceResultComponent from '../salesforce/SalesforceResultComponent';
import { handleError } from 'services/ErrorService/ErrorService';

// TODO: refactor this later as it brake SRP
const SearchResultList = ({
  listType,
  resultList,
  resultClickAction,
  zendeskConfig,
  orderingSystem,
  selectedSubscriptionsIds,
  markAsOrder,
  hideDeleteButton,
}) => {
  const {
    SEARCH_ORDERS,
    SEARCH_TICKETS,
    SEARCH_MACROS,
    SEARCH_KB,
    SEARCH_CANCEL_SUBSCRIPTIONS_DECISION_TREE,
    SEARCH_ORDERS_DECISION_TREE,
    NON_TABLE_SEARCH_OPTIONS,
    SEARCH_RETURNS_DECISION_TREE,
  } = searchTypes;

  const searchResultList = resultList.map((result = {}, index) => {
    const reactElementKey = `search-result-list-${listType}-result-${index}`;
    const even = index % 2 === 0;

    switch (listType) {
      case SEARCH_ORDERS:
        switch (orderingSystem) {
          case 'shopify':
            if (zendeskConfig.isZendesk) {
              // TODO: Needs updated styles
              return (
                <ZendeskOrderSearchResult
                  key={reactElementKey}
                  result={result}
                  returnUrl={zendeskConfig.returnUrl}
                  customMessage={zendeskConfig.customMessage}
                />
              );
            }

            return (
              <ShopifyOrderSearchResult
                key={reactElementKey}
                result={result}
                clickAction={resultClickAction}
                even={even}
              />
            );
          case 'amazon':
            return (
              <AmazonOrderSearchResult
                key={reactElementKey}
                result={result}
                clickAction={resultClickAction}
                even={even}
              />
            );
          case 'customSeller':
            return (
              <CustomSellerOrderSearchResult
                key={reactElementKey}
                order={result}
                clickAction={resultClickAction}
                even={even}
              />
            );
          case 'simplrOrder':
            return (
              <SimplrOrderSearchResult
                key={reactElementKey}
                result={result}
                clickAction={resultClickAction}
                even={even}
              />
            );
          case 'custom_rbi':
            return (
              <RbiSearchResultComponent
                key={reactElementKey}
                result={result}
                clickAction={resultClickAction}
                even={even}
              />
            );
          case 'salesforce':
            return (
              <SalesforceResultComponent
                key={reactElementKey}
                result={result}
                clickAction={resultClickAction}
                even={even}
              />
            );
          default:
            handleError({ customMessage: 'Invalid ordering system!' });

            return '';
        }
      case SEARCH_TICKETS:
        return (
          <TicketSearchResult
            key={reactElementKey}
            index={index}
            result={result}
            clickAction={resultClickAction}
            hideDeleteButton={hideDeleteButton}
          />
        );
      case SEARCH_KB:
      case SEARCH_MACROS:
        return (
          <KbOrMacroSearchResult
            key={reactElementKey}
            result={result}
            index={index}
            clickAction={resultClickAction}
            resultType={listType}
          />
        );
      case SEARCH_CANCEL_SUBSCRIPTIONS_DECISION_TREE:
        return (
          <CancelSubscriptionResult
            key={reactElementKey}
            result={result}
            checked={selectedSubscriptionsIds.includes(result.id)}
            clickAction={resultClickAction}
          />
        );

      case SEARCH_ORDERS_DECISION_TREE:
        switch (orderingSystem) {
          case 'shopify':
          case 'custom_rbi':
          case 'salesforce':
          case 'bigCommerce':
          case 'revolve':
          case 'common':
            return (
              <DTOrderSearchResult
                key={reactElementKey}
                result={result}
                clickAction={resultClickAction}
                resultList={resultList}
                index={index}
                markAsOrder={markAsOrder}
              />
            );
          default:
            handleError({ customMessage: 'Invalid ordering system!' });

            return '';
        }
      case SEARCH_RETURNS_DECISION_TREE:
        return (
          <DTReturnsSearchResult
            key={reactElementKey}
            result={result}
            clickAction={resultClickAction}
            resultList={resultList}
            index={index}
            markAsOrder={markAsOrder}
          />
        );
      default:
        return null;
    }
  });

  if (NON_TABLE_SEARCH_OPTIONS.includes(listType)) {
    return searchResultList;
  }
  if (listType === SEARCH_RETURNS_DECISION_TREE) {
    return searchResultList;
  }

  return <tbody>{searchResultList}</tbody>;
};

export default SearchResultList;
